
export interface DogSchool {
  id: string;
  name: string;
  street: string;
  postalCode: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  email: string;
  website: string;
  description: string;
  latitude?: number;
  longitude?: number;
  distance?: number;
  openingHours?: {
    de: string;
    en: string;
  };
  googleReview?: number;
  reviewCount?: number;
  imageUrl?: string;
  features?: {
    hasFreeParking: boolean;
    isWheelchairAccessible: boolean;
    hasPrivateLessons: boolean;
    hasGroupLessons: boolean;
    hasDogLicense: boolean;
    isLGBTQFriendly: boolean;
    hasMultiLanguageSupport: boolean;
  };
  reviews?: string[];
  googleMapsUrl?: string;
  imageAlt?: string;
  
  // Adding missing properties that are being referenced in components
  phoneNumber?: string; // Alias for phone
  address?: string;    // Alias for street
  location?: {        // Computed property based on latitude/longitude
    lat: number;
    lng: number;
  };
}

export const dogSchools: DogSchool[] = [
  {
    id: '1',
    name: 'Hundeschule Berlin Mitte',
    street: 'Alexanderplatz 1',
    city: 'Berlin',
    state: 'Berlin',
    country: 'Germany',
    postalCode: '10178',
    openingHours: {
      de: 'Mo-Fr: 9:00-18:00, Sa: 10:00-14:00',
      en: 'Mon-Fri: 9am-6pm, Sat: 10am-2pm',
    },
    phone: '+49 30 1234567',
    email: 'info@hundeschule-berlin.de',
    website: 'https://hundeschule-berlin.de',
    description: 'Professionelle Hundeschule in Berlin',
    latitude: 52.520008,
    longitude: 13.404954,
    googleReview: 4.7,
    reviewCount: 127,
    imageUrl: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    imageAlt: 'Hundeschule Berlin Mitte - Hundetraining und Erziehung im Zentrum von Berlin',
    features: {
      hasFreeParking: true,
      isWheelchairAccessible: true,
      hasPrivateLessons: true,
      hasGroupLessons: true,
      hasDogLicense: true,
      isLGBTQFriendly: true,
      hasMultiLanguageSupport: true,
    },
  },
  {
    id: '2',
    name: 'Hundeschule München',
    street: 'Marienplatz 8',
    city: 'München',
    state: 'Bayern',
    country: 'Germany',
    postalCode: '80331',
    openingHours: {
      de: 'Mo-Fr: 10:00-19:00, Sa: 9:00-16:00',
      en: 'Mon-Fri: 10am-7pm, Sat: 9am-4pm',
    },
    phone: '+49 89 9876543',
    email: 'info@hundeschule-muenchen.de',
    website: 'https://hundeschule-muenchen.de',
    description: 'Professionelle Hundeschule in München',
    googleReview: 4.9,
    reviewCount: 203,
    imageUrl: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80',
    imageAlt: 'Hundeschule München - Professionelle Hundetrainer in Bayern mit Einzel- und Gruppentraining',
    features: {
      hasFreeParking: true,
      isWheelchairAccessible: false,
      hasPrivateLessons: true,
      hasGroupLessons: true,
      hasDogLicense: false,
      isLGBTQFriendly: false,
      hasMultiLanguageSupport: false,
    },
  },
  {
    id: '3',
    name: 'Wiener Hundeschule',
    street: 'Stephansplatz 3',
    city: 'Wien',
    state: 'Wien',
    country: 'Austria',
    postalCode: '1010',
    openingHours: {
      de: 'Mo-Fr: 9:00-17:00, Sa: 10:00-15:00',
      en: 'Mon-Fri: 9am-5pm, Sat: 10am-3pm',
    },
    phone: '+43 1 2345678',
    email: 'info@wiener-hundeschule.at',
    website: 'https://wiener-hundeschule.at',
    description: 'Hundeschule in Wien, Österreich',
    googleReview: 4.6,
    reviewCount: 98,
    imageUrl: 'https://images.unsplash.com/photo-1534361960057-19889db9621e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    imageAlt: 'Wiener Hundeschule - Hundetraining und Verhaltenstherapie in Wien, Österreich',
    features: {
      hasFreeParking: false,
      isWheelchairAccessible: true,
      hasPrivateLessons: true,
      hasGroupLessons: false,
      hasDogLicense: true,
      isLGBTQFriendly: false,
      hasMultiLanguageSupport: false,
    },
  },
  {
    id: '4',
    name: 'Zürcher Hundeschule',
    street: 'Bahnhofstrasse 25',
    city: 'Zürich',
    state: 'Zürich',
    country: 'Switzerland',
    postalCode: '8001',
    openingHours: {
      de: 'Mo-Fr: 8:30-18:30, Sa: 9:00-16:00',
      en: 'Mon-Fri: 8:30am-6:30pm, Sat: 9am-4pm',
    },
    phone: '+41 44 1234567',
    email: 'info@zuercher-hundeschule.ch',
    website: 'https://zuercher-hundeschule.ch',
    description: 'Hundeschule in Zürich, Schweiz',
    googleReview: 4.8,
    reviewCount: 156,
    imageUrl: 'https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    imageAlt: 'Zürcher Hundeschule - Hundetraining und Erziehungskurse in der Schweiz mit zertifizierten Trainern',
    features: {
      hasFreeParking: true,
      isWheelchairAccessible: true,
      hasPrivateLessons: false,
      hasGroupLessons: true,
      hasDogLicense: true,
      isLGBTQFriendly: false,
      hasMultiLanguageSupport: false,
    },
  },
  {
    id: '5',
    name: 'Hundeschule Hamburg',
    street: 'Reeperbahn 153',
    city: 'Hamburg',
    state: 'Hamburg',
    country: 'Germany',
    postalCode: '20359',
    openingHours: {
      de: 'Mo-Fr: 9:00-18:00, Sa: 10:00-14:00',
      en: 'Mon-Fri: 9am-6pm, Sat: 10am-2pm',
    },
    phone: '+49 40 9876541',
    email: 'info@hundeschule-hamburg.de',
    website: 'https://hundeschule-hamburg.de',
    description: 'Hundeschule in Hamburg, Norddeutschland',
    googleReview: 4.5,
    reviewCount: 112,
    imageUrl: 'https://images.unsplash.com/photo-1529429617124-95b109e86bb8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1635&q=80',
    imageAlt: 'Hundeschule Hamburg - Hundetraining und Verhaltenstraining in Norddeutschland mit individueller Betreuung',
    features: {
      hasFreeParking: true,
      isWheelchairAccessible: false,
      hasPrivateLessons: true,
      hasGroupLessons: true,
      hasDogLicense: true,
      isLGBTQFriendly: false,
      hasMultiLanguageSupport: false,
    },
  },
];

// Function to filter dog schools by country
export const getDogSchoolsByCountry = (country: string): DogSchool[] => {
  return dogSchools.filter((school) => school.country.toLowerCase() === country.toLowerCase());
};

// Function to filter dog schools by state
export const getDogSchoolsByState = (country: string, state: string): DogSchool[] => {
  return dogSchools.filter(
    (school) => 
      school.country.toLowerCase() === country.toLowerCase() && 
      school.state.toLowerCase() === state.toLowerCase()
  );
};

// Function to filter dog schools by postal code and radius
export const getDogSchoolsByPostalCode = (postalCode: string, radiusKm: number): DogSchool[] => {
  // This is a simplified version. In a real application, you would need to:
  // 1. Convert postal code to coordinates (geocoding)
  // 2. Calculate the distance between each dog school and the given coordinates
  // 3. Filter schools based on the radius
  
  // For now, we'll just return all schools if postalCode is provided, to simulate the feature
  if (postalCode && postalCode.trim() !== '') {
    return dogSchools;
  }
  return [];
};
